import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ProfessionForm from './ProfessionForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewProfessionModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( values ) => {
        this.setState( { fetching: true } );
        this.props.createProfession( { title: values.title } )
        .then( ( profession ) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( profession );
        } );
    }



    render() {
        return (
            <DLModal title='New Profession'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ProfessionForm next={ this.submitHandler } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createProfession: ( data ) => {
            return dAPI.post( '/admin/professions', data );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewProfessionModal );
